'use client';

import Link from '@eliadmin/core/src/components/link';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { Button } from '../ui/button';
import { ButtonIcon } from '../ui/button-icon';
import { useComparisonStore } from '../../stores/comparison-store';

export function HeaderComparisionButton() {
  const count = useComparisonStore(s => s.products.length);

  return (
    <Button asChild variant={'none'} size={'none'} className="relative">
      <Link aria-label="Porovnanie produktov" prefetch={false} href={ROUTES.PRODUCT_COMPARISON()}>
        <ButtonIcon
          alt="Porovnanie"
          url="/images/icons/balance-scale-black.svg"
          className="max-h-6 min-h-6 min-w-6 max-w-6"
        />
        {count > 0 && (
          <span className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-white">
            {count}
          </span>
        )}
      </Link>
    </Button>
  );
}
